import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { ReactNode } from "react";
import { RealtimeStatus } from '@/components/RealtimeStatus';
import { SyncStatus } from '@/components/ui/sync-status';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <main className="flex-1">
          <div className="container py-4">
            <div className="flex items-center justify-between mb-6">
              <SidebarTrigger />
              <div className="text-right">
                <div className="text-sm text-gray-500">Today</div>
                <div className="font-medium">
                  {new Date().toLocaleDateString("en-US", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </div>
              </div>
              <div className="flex items-center gap-2">
                <RealtimeStatus />
                <SyncStatus className="w-32" />
              </div>
            </div>
            {children}
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
}
